












import DoorIcon from '../../../../assets/svg/door.svg';
import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
  name: "ControlPanelLeave",
  components: { DoorIcon }
})
export default class ControlPanelLeave extends Vue {
    @Prop({ default: false }) isRound: boolean;
}
